import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useUpdateTamalContext} from '../contexts/UpdateTamalContext';
import DataItem from '../../_common/components/DataItem';
import {integerValue} from '../../../../utils';
import styles from './styles.module.scss';

export default function UpdateTamal() {
  const {formik, update} = useUpdateTamalContext();
  const prefix = 'transfersByAgent-update-tamal';

  return (
    <div className={styles.card}>
        <h3>
          <FormattedMessage id={`${prefix}-header`} defaultMessage="Confirm data for national insurance"/>
        </h3>
      <div className={'d-flex justify-content-between align-items-end w-100'}>
        <DataItem
          fieldId={'tamalID'}
          label={<FormattedMessage id={`${prefix}-tamalID`} defaultMessage="Shiklulit ID"/>}
          value={formik.values.tamalID}
          topLabelStyle={styles.label}
          customInputStyle={styles.input}
          onChange={integerValue}
          containerStyle={'w-500px mr-4'}
        />
        <button
          className={styles.primary}
          onClick={() => update()}
          disabled={!formik.isValid}
        >
          <FormattedMessage id={`${prefix}-update`} defaultMessage="Update"/>
        </button>
      </div>
    </div>
  )
}
